import { useState } from "react"
import styled from "styled-components"

import { colors } from "@minuthq/meatball-ui-react"

import { GuestConversation } from "src/components/GuestInbox/GuestConversations/GuestConversation"
import { ParadiseHomeCompassSandboxGuestList } from "src/components/Paradise/ParadiseHomes/ParadiseHomeDetails/ParadiseHomeCompassSandbox/ParadiseHomeCompassSandboxGuestList"
import { ScrollArea } from "src/components/ScrollArea/ScrollArea"

export function ParadiseHomeCompassSandbox({
  homeId,
  orgId,
}: {
  homeId: string
  orgId: string
}) {
  const [selectedGuestId, setSelectedGuestId] = useState<string | null>(null)

  return (
    <Wrapper>
      <StyledScrollArea>
        <ParadiseHomeCompassSandboxGuestList
          homeId={homeId}
          orgId={orgId}
          selectedGuestId={selectedGuestId}
          onSelectGuest={setSelectedGuestId}
        />
      </StyledScrollArea>

      <ScrollArea>
        {selectedGuestId && (
          <GuestConversation
            orgId={orgId}
            guestId={selectedGuestId}
            showSendAsSelector
            showSendMessageSelector
          />
        )}
      </ScrollArea>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  height: 85vh;
  display: grid;
  grid-template-columns: minmax(200px, 300px) 1fr;
  border-bottom: 1px solid ${colors.divider};
  overflow: hidden;
`

const StyledScrollArea = styled(ScrollArea)`
  border-right: 1px solid ${colors.divider};
`
